/* External */
import { memo, useMemo } from 'react';
import PropTypes from 'prop-types';

/* Ott-common */
import { ScrubbingDirection, ScrubbingSpeed } from '@dtvgo/progress-bar';
import { usePlayerTime, usePlayerDuration, usePlayerActions } from '@dtvgo/player-context';

/* Components */
import FocusableProgressBar from './FocusableProgressBar';

function VodFocusableProgressBar({
  className,
  scrubbing,
  isScrubbing,
  onSeekingStart,
  onSeekingEnd,
  onSeekableStartReached,
  onSeekableEndReached,
  onKeyDown,
  onArrowPress,
  onBecameFocused,
  onBecameBlurred,
}) {
  return (
    <FocusableProgressBar
      className={className}
      progress={usePlayerTime()}
      duration={usePlayerDuration()}
      scrubbing={scrubbing}
      isScrubbing={isScrubbing}
      onSeek={usePlayerActions().seek}
      onSeekingStart={onSeekingStart}
      onSeekingEnd={onSeekingEnd}
      onSeekableStartReached={onSeekableStartReached}
      onSeekableEndReached={onSeekableEndReached}
      onKeyDown={onKeyDown}
      onArrowPress={onArrowPress}
      onBecameFocused={onBecameFocused}
      onBecameBlurred={onBecameBlurred}
    >
      {useMemo(() => (
        <>
          <FocusableProgressBar.ProgressFill />
          <FocusableProgressBar.ProgressDot />
          <FocusableProgressBar.SeekingFill />
          <FocusableProgressBar.SeekingDot tooltipBgColor="transparent" />
          <FocusableProgressBar.MouseOver tooltipBgColor="transparent" />
        </>
      ), [])}
    </FocusableProgressBar>
  );
}

VodFocusableProgressBar.propTypes = {
  className: PropTypes.string,
  scrubbing: PropTypes.shape({
    direction: PropTypes.oneOf(Object.values(ScrubbingDirection)),
    speed: PropTypes.oneOf(Object.values(ScrubbingSpeed)),
  }),
  isScrubbing: PropTypes.bool,
  onSeekingStart: PropTypes.func,
  onSeekingEnd: PropTypes.func,
  onSeekableStartReached: PropTypes.func,
  onSeekableEndReached: PropTypes.func,
  onKeyDown: PropTypes.func,
  onArrowPress: PropTypes.func,
  onBecameFocused: PropTypes.func,
  onBecameBlurred: PropTypes.func,
};

VodFocusableProgressBar.defaultProps = {
  className: '',
  scrubbing: undefined,
  isScrubbing: false,
  onSeekingStart: undefined,
  onSeekingEnd: undefined,
  onSeekableStartReached: undefined,
  onSeekableEndReached: undefined,
  onKeyDown: undefined,
  onArrowPress: undefined,
  onBecameFocused: undefined,
  onBecameBlurred: undefined,
};

export default memo(VodFocusableProgressBar);
